import script from "./EditActivityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditActivityForm.vue?vue&type=script&setup=true&lang=js"

import "./EditActivityForm.vue?vue&type=style&index=0&id=75241e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75241e56"]])

export default __exports__